// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multiselect__tags {\n\tborder-radius: 0;\n\tborder-color: #ccc;\n}\n.event-participant {\n\tmargin-top: 50px;\n}\n.company-details {\n\tmargin-top: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
